// extracted by mini-css-extract-plugin
module.exports = {"dropdownGroup":"DropdownGroup_dropdownGroup__2H2Br","name":"DropdownGroup_name__22r3j"};